import { useCallback, useEffect, useRef, useState } from 'react';
import { loadDrawerWidth, saveDrawerWidth } from './persistence.js';
import { clampWidth, computeDefaultWidth } from './drawerFormat.js';

export const useResizableDrawerWidth = () => {
  const [drawerWidth, setDrawerWidth] = useState(() => clampWidth(loadDrawerWidth() ?? computeDefaultWidth()));
  const [isResizing, setIsResizing] = useState(false);
  const widthRef = useRef(drawerWidth);

  useEffect(() => { widthRef.current = drawerWidth; }, [drawerWidth]);
  useEffect(() => {
    const onWindowResize = () => setDrawerWidth((width) => clampWidth(width));
    window.addEventListener('resize', onWindowResize);
    return () => window.removeEventListener('resize', onWindowResize);
  }, []);

  const startResize = useCallback((event) => {
    event.preventDefault();
    setIsResizing(true);
    const prevUserSelect = document.body.style.userSelect;
    const prevCursor = document.body.style.cursor;
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
    const onMove = (moveEvent) => {
      const next = clampWidth(window.innerWidth - moveEvent.clientX);
      widthRef.current = next;
      setDrawerWidth(next);
    };
    const onUp = () => {
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.body.style.userSelect = prevUserSelect;
      document.body.style.cursor = prevCursor;
      setIsResizing(false);
      saveDrawerWidth(widthRef.current);
    };
    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp);
  }, []);

  const resetWidth = useCallback(() => {
    const width = computeDefaultWidth();
    setDrawerWidth(width);
    saveDrawerWidth(width);
  }, []);

  return { drawerWidth, isResizing, resetWidth, startResize };
};
